<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
    <Toast />
    <ConfirmDialog></ConfirmDialog>
    <ScrollTop />
  </div>
</template>

<script>
import Toast from "primevue/toast";
import ConfirmDialog from "primevue/confirmdialog";
import ScrollTop from "primevue/scrolltop";
import StorageService from "./services/StorageService";

const defaultLayout = "AuthLayout";

export default {
  components: {
    Toast,
    ConfirmDialog,
    ScrollTop,
  },
  computed: {
    layout() {
      const layout = this.$route.meta.layout || defaultLayout;
      return () => import(`@/components/layout/${layout}.vue`);
    },
  },
  mounted() {
    // On page refreshes this will get the taskCount for navigation.
    // Since this is used here, it will also fire on login.
    // However, if user is not available, it would not succeed.
    //this.$store.dispatch("task/getTaskCount");

    // On page refreshes these master API's are triggered first to set
    // all master related records.
    //this.$store.dispatch("master/getMasterLocations");
    //this.$store.dispatch("master/getMasterJobTypes");

    // Event listener to check if user has changed
    window.addEventListener("storage", (event) => {
      if (event.key === "user") {
        const user = StorageService.read("user");
        if (user) {
          this.$store.dispatch("user/setUser", user);
        } else {
          this.$router.push({ name: "login" });
        }
      }
    });
  },
};
</script>
